import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import useHover from "hooks/useHover";
import { Icon, Typography, RaiseColors, makeStyles, Menu, MenuItem, useTheme } from "client/componentLibrary";
import { Tab as MuiTab } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      tabRoot: _defineProperty({
        padding: "0px",
        margin: "8px 16px",
        width: "initial",
        minWidth: "initial",
        minHeight: "18px",
        opacity: 1
      }, theme.breakpoints.up("laptop"), {
        marginLeft: "24px",
        marginRight: "24px"
      }),
      tabLabel: {
        display: "flex",
        alignItems: "center"
      }
    };
  });
};
var GroupTab = function GroupTab(_ref) {
  var _tabGroup$activeGroup;
  var label = _ref.label,
    activeValue = _ref.activeValue,
    activeGroupValue = _ref.activeGroupValue,
    onGroupTabChange = _ref.onGroupTabChange,
    tabGroup = _ref.tabGroup,
    value = _ref.value;
  var _useHover = useHover(),
    _useHover2 = _slicedToArray(_useHover, 2),
    hoverRef = _useHover2[0],
    isHoveringOverItem = _useHover2[1];
  var classes = useStyles()();
  var isSelected = activeValue === value;
  var currentLabel = isSelected ? (_tabGroup$activeGroup = tabGroup[activeGroupValue]) === null || _tabGroup$activeGroup === void 0 ? void 0 : _tabGroup$activeGroup.label : label;
  var labelColor = isSelected ? RaiseColors.space1400 : isHoveringOverItem ? RaiseColors.black : RaiseColors.gray300;
  var labelWeight = isSelected ? "semibold" : "regular";
  return /*#__PURE__*/_jsx(Menu, {
    "data-testid": "group-tab-menu",
    toggleComponent: /*#__PURE__*/_jsx(MuiTab, {
      ref: hoverRef,
      disableRipple: true,
      value: value,
      label: /*#__PURE__*/_jsxs("div", {
        className: classes.tabLabel,
        children: [/*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          variant: "paragraph_small",
          weight: labelWeight,
          color: labelColor,
          children: currentLabel
        }), /*#__PURE__*/_jsx(Icon, {
          color: labelColor,
          fontSize: 13,
          className: "far fa-chevron-down",
          style: {
            marginLeft: 4
          }
        })]
      }),
      classes: {
        root: classes.tabRoot
      }
    }),
    children: _mapInstanceProperty(tabGroup).call(tabGroup, function (tab, index) {
      return /*#__PURE__*/_jsx(MenuItem, {
        onClick: function onClick() {
          onGroupTabChange(value, index);
        },
        children: /*#__PURE__*/_jsxs("span", {
          style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 8
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            children: tab.label
          }), tab.trailingIcon]
        })
      }, index);
    })
  });
};
export default GroupTab;